import type { CashbookDebtCategory } from '@finvox/shared/cashbook';
import { useTranslation } from 'react-i18next';
import { CashbookDebtQuickAdd } from '@/components/cashbook/CashbookDebtQuickAdd';
import { Card } from '@/components/ui/Card';

type Props = {
  open: boolean;
  onClose: () => void;
  amount: string;
  categoryKey: string;
  creditor: string;
  date: string;
  memo: string;
  busy: boolean;
  disabled: boolean;
  debtOwners: string[];
  customDebtCategories?: CashbookDebtCategory[];
  onAmountChange: (v: string) => void;
  onCategoryChange: (v: string) => void;
  onCreditorChange: (v: string) => void;
  onDateChange: (v: string) => void;
  onMemoChange: (v: string) => void;
  onAdd: () => void | Promise<void>;
};

export function CashbookAddDebtDialog({
  open,
  onClose,
  ...formProps
}: Props) {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cashbook-add-debt-title"
    >
      <Card className="flex max-h-[90vh] w-full max-w-3xl flex-col overflow-hidden p-6 shadow-lg">
        <h2 id="cashbook-add-debt-title" className="shrink-0 text-lg font-semibold">
          {t('cashbook.debts.incurTitle')}
        </h2>
        <div className="mt-4 min-h-0 flex-1 overflow-y-auto">
          <CashbookDebtQuickAdd embedded onCancel={onClose} {...formProps} />
        </div>
      </Card>
    </div>
  );
}
